import type { PostPreviewProps, SubComponentsReturnType } from '../types';

import { EXECUTORS } from './executors';

export function useSubComponentsFactory(props: PostPreviewProps): SubComponentsReturnType {
	return EXECUTORS[props.variant](props);
}
